module.exports = __webpack_public_path__ + "img/Memtako.15a2b05c.svg";